module.exports = require("@swa-ui/core/src/Grid/Grid.module.scss");